var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignature40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1720_2061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0002C12 10.8939 12.8938 10.0002 14 10.0002C15.1062 10.0002 16 10.8939 16 12.0002V12.4877C16 14.2189 15.85 15.9439 15.5562 17.6439L10.2812 19.2252C7.74375 19.9877 6.00625 22.3252 6.00625 24.9752V29.4689C6.00625 31.9689 8.0375 34.0002 10.5375 34.0002C12.1625 34.0002 13.6625 33.1314 14.4688 31.7189L15.3375 30.2002C17.0125 27.2627 18.2437 24.0939 18.9875 20.7939L24.8875 19.0252L24.1063 21.3689C23.9 21.9814 24.0063 22.6502 24.3813 23.1689C24.7563 23.6877 25.3625 24.0002 26.0063 24.0002H34.0062C35.1125 24.0002 36.0062 23.1064 36.0062 22.0002C36.0062 20.8939 35.1125 20.0002 34.0062 20.0002H28.7812L29.9062 16.6314C30.1437 15.9252 29.9625 15.1439 29.4438 14.6064C28.925 14.0689 28.15 13.8689 27.4312 14.0814L19.775 16.3814C19.925 15.0877 20 13.7939 20 12.4877V12.0002C20 8.68768 17.3125 6.00018 14 6.00018C10.6875 6.00018 8 8.68768 8 12.0002V14.0002C8 15.1064 8.89375 16.0002 10 16.0002C11.1062 16.0002 12 15.1064 12 14.0002V12.0002ZM11.425 23.0627L14.4875 22.1439C13.8375 24.2564 12.9563 26.2939 11.8562 28.2189L10.9875 29.7377C10.8938 29.9002 10.7188 30.0064 10.525 30.0064C10.2312 30.0064 9.99375 29.7689 9.99375 29.4752V24.9814C9.99375 24.1002 10.575 23.3189 11.4187 23.0627H11.425ZM1.5 27.0002C0.66875 27.0002 0 27.6689 0 28.5002C0 29.3314 0.66875 30.0002 1.5 30.0002H4.01875C4.00625 29.8252 4 29.6502 4 29.4689V27.0002H1.5ZM38.5 30.0002C39.3312 30.0002 40 29.3314 40 28.5002C40 27.6689 39.3312 27.0002 38.5 27.0002H19.1187C18.7 28.0189 18.2313 29.0189 17.725 30.0002H38.5Z",
    fill: "#F38A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1720_2061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature40Px);
export default __webpack_public_path__ + "static/media/signature_40px.d4d19fea9443db68483ea85d3e5c4fc1.svg";
export { ForwardRef as ReactComponent };